<template>
   <main>
      <div class="breadcrumb">
      <div class="container">
          <ul>
              <li><router-link to="/">HARUMIFLAG</router-link></li>
              <li><router-link to="/timeout">セッションがタイムアウトしました</router-link></li>
          </ul>
      </div>
      </div>
      <div class="cms">
            <div class="container">
                <div class="cms-cont">
                    <h2>セッションがタイムアウトしました</h2>
                    <div class="cms-cont__top">
                        <p style="text-align: center;">申し訳ございません。<br>
                            しばらく経ってから再度アクセスしてください。</p>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: 'TimeOut',
  components: {
  }
}
</script>
